import { render, staticRenderFns } from "./SLAmend.vue?vue&type=template&id=37442b5a&"
import script from "./SLAmend.vue?vue&type=script&lang=js&"
export * from "./SLAmend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports